module.exports = __webpack_public_path__ + "static/comfort-9a36c1a2b872412b314274bd57112431.png";